import { render, staticRenderFns } from "./CartPanel_Culinary.vue?vue&type=template&id=2952a518&scoped=true&"
import script from "./CartPanel_Culinary.vue?vue&type=script&lang=js&"
export * from "./CartPanel_Culinary.vue?vue&type=script&lang=js&"
import style0 from "./CartPanel_Culinary.vue?vue&type=style&index=0&id=2952a518&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2952a518",
  null
  
)

export default component.exports